// Collection Tag Fix
// /collections/tops/T-SHIRTS や /collections/faf/tops のようなURLで商品が表示されない問題を修正

(function() {
    'use strict';
    
    // ページ読み込み完了後に実行
    function init() {
        console.log('Collection Tag Fix: Initializing...');
        
        // URLパスからタグページかどうかを判定
        var pathname = window.location.pathname;
        var isTagPage = pathname.match(/\/collections\/[^\/]+\/[^\/]+/);
        
        if (!isTagPage) {
            console.log('Collection Tag Fix: Not a tag page, skipping...');
            return;
        }
        
        console.log('Collection Tag Fix: Detected tag page:', pathname);
        
        // 商品リストを保護
        protectProductList();
        
        // Boost PFSの初期化を監視
        monitorBoostPFS();
    }
    
    // 商品リストを保護する関数
    function protectProductList() {
        var productList = document.querySelector('.boost-pfs-filter-products');
        
        if (!productList) {
            console.log('Collection Tag Fix: Product list not found');
            return;
        }
        
        // 初期の商品リストを保存
        var originalContent = productList.innerHTML;
        var productCount = productList.children.length;
        
        console.log('Collection Tag Fix: Found', productCount, 'products, protecting them...');
        
        // 商品リストが消去されるのを防ぐ
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && productList.children.length === 0 && originalContent) {
                    console.log('Collection Tag Fix: Product list was cleared, restoring...');
                    
                    // 少し遅延してから復元（Boost PFSの処理が完了するのを待つ）
                    setTimeout(function() {
                        if (productList.children.length === 0) {
                            productList.innerHTML = originalContent;
                            console.log('Collection Tag Fix: Product list restored successfully');
                        }
                    }, 200);
                }
            });
        });
        
        // 商品リストの変更を監視
        observer.observe(productList, {
            childList: true,
            subtree: true
        });
        
        // 定期的にもチェック
        var checkInterval = setInterval(function() {
            if (productList.children.length === 0 && originalContent) {
                console.log('Collection Tag Fix: Periodic check - restoring product list');
                productList.innerHTML = originalContent;
            }
        }, 1000);
        
        // 10秒後にチェックを停止
        setTimeout(function() {
            clearInterval(checkInterval);
            observer.disconnect();
            console.log('Collection Tag Fix: Protection completed');
        }, 10000);
    }
    
    // Boost PFSの初期化を監視する関数
    function monitorBoostPFS() {
        // Boost PFSが読み込まれるまで待機
        function waitForBoostPFS() {
            if (typeof BoostPFS !== 'undefined') {
                console.log('Collection Tag Fix: Boost PFS detected, monitoring initialization...');
                
                // 元の初期化関数を保存
                var originalInit = BoostPFS.init;
                
                // 初期化関数をオーバーライド
                BoostPFS.init = function() {
                    console.log('Collection Tag Fix: Intercepting Boost PFS initialization');
                    
                    // 元の初期化を実行
                    var result = originalInit.apply(this, arguments);
                    
                    // 初期化後に商品リストをチェック
                    setTimeout(function() {
                        var productList = document.querySelector('.boost-pfs-filter-products');
                        if (productList && productList.children.length === 0) {
                            console.log('Collection Tag Fix: Boost PFS cleared products, triggering restoration...');
                            // 商品リストの復元をトリガー
                            var event = new CustomEvent('collectionTagFix:restoreProducts');
                            document.dispatchEvent(event);
                        }
                    }, 300);
                    
                    return result;
                };
                
                console.log('Collection Tag Fix: Boost PFS monitoring activated');
            } else {
                setTimeout(waitForBoostPFS, 100);
            }
        }
        
        waitForBoostPFS();
    }
    
    // 商品リスト復元イベントのリスナー
    document.addEventListener('collectionTagFix:restoreProducts', function() {
        var productList = document.querySelector('.boost-pfs-filter-products');
        if (productList && productList.children.length === 0) {
            // ページを再読み込みして商品を復元
            console.log('Collection Tag Fix: Reloading page to restore products...');
            window.location.reload();
        }
    });
    
    // ページ読み込み完了時に実行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    // URL変更時の処理
    function handleUrlChange() {
        setTimeout(init, 100);
    }
    
    // History APIの変更を監視
    var originalPushState = history.pushState;
    var originalReplaceState = history.replaceState;
    
    history.pushState = function() {
        originalPushState.apply(this, arguments);
        handleUrlChange();
    };
    
    history.replaceState = function() {
        originalReplaceState.apply(this, arguments);
        handleUrlChange();
    };
    
    // popstateイベントを監視
    window.addEventListener('popstate', handleUrlChange);
    
    console.log('Collection Tag Fix: Script loaded successfully');
})();